import { ErrorLogComponent } from '@cian/error-log-component';
import { UiKitContextProvider } from '@cian/ui-kit/context';
import { FC } from 'react';
import { Provider } from 'react-redux';

import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { ApplicationContext } from 'shared/utils/applicationContext';

import { ProjectsListPageContainer } from '../admin/ProjectsListPageContainer';
import { EApplicationType } from 'shared/types/applicationType';
import { ProjectEditorPageContainer } from '../admin/ProjectEditorPageContainer';

export interface IApplicationProps {
  context: IApplicationContext;
  reduxStore: TReduxStore;
}

const ApplicationTypes = {
  [EApplicationType.ProjectsList]: <ProjectsListPageContainer />,
  [EApplicationType.ProjectEditor]: <ProjectEditorPageContainer />,
  [EApplicationType.ProjectPreview]: null,
  [EApplicationType.PromoPage]: null,
};

export const Application: FC<IApplicationProps> = ({ reduxStore, context }) => {
  const {
    logger,
    custom: { initialDeviceType, applicationType },
  } = context;

  return (
    <ErrorLogComponent logger={logger}>
      <ApplicationContext.Provider value={context}>
        <UiKitContextProvider deviceType={initialDeviceType}>
          <Provider store={reduxStore}>{ApplicationTypes[applicationType]}</Provider>
        </UiKitContextProvider>
      </ApplicationContext.Provider>
    </ErrorLogComponent>
  );
};
